import {createI18n} from 'vue-i18n'

import en from '/src/lang/en.json';
import zh_Hant from '/src/lang/zh-Hant.json';
import zh_Hans from '/src/lang/zh-Hans.json';
import ja from '/src/lang/ja.json';
import ko from '/src/lang/ko.json';

import util from "@/common/util";
import config from "@/common/api/config";

const _cache_lang = util.getCache('lang');
const lang = _cache_lang ? _cache_lang : "en";
util.setCache("lang", lang)

export default createI18n({
    legacy: true, // 让 setup 函数可以通过 t 访问
    globalInjection: true, // 让 template 可以像 vue2 那样使用 $t 来访问
    locale: lang,
    messages: {
        'zh-Hant': zh_Hant,
        'zh_Hans': zh_Hans,
        'en': en,
        'ja': ja,
        'ko': ko,
    }
})